// extracted by mini-css-extract-plugin
export var navbar = "navbar-module--navbar--BHcaw";
export var nav_title = "navbar-module--nav_title--zX4M7";
export var mode = "navbar-module--mode--f7rLR";
export var nav_resume = "navbar-module--nav_resume--vw-GN";